import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=2f6719a1&scoped=true&"
import script from "./BurgerButton.vue?vue&type=script&lang=js&"
export * from "./BurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=2f6719a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6719a1",
  null
  
)

export default component.exports